module.exports = __webpack_public_path__ + "static/img/方胜磐石的核心价值背景@2x.d025334.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/方胜磐石的核心价值背景@2x.png
// module id = zE7y
// module chunks = 0